import API from "../../api/api";
import React, { Component } from "react";
import ReactTimeAgo from "react-time-ago";
import "../../styles/css/Jobs/Comments.css";
import CircularProgress from "@material-ui/core/CircularProgress";
import GetAppIcon from "@material-ui/icons/GetApp";
// Import React FilePond
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
// Import FilePond styles
import "filepond/dist/filepond.min.css";

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const userRole = localStorage.getItem("userRole");
const userId = localStorage.getItem("userId");
const userName = localStorage.getItem("userName");

class Comments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      commentText: "",
      files: [],
      documents: [],
      isCommenting: false,
      commentDisabled: true,
      isDownloaded: true,
    };
    this.starRate = [];
  }

  componentDidMount() {}

  handleInputChange = (e) => {
    this.setState({ commentText: e.target.value }, () =>
      this.setState({
        commentDisabled: this.state.commentText === "" ? true : false,
      })
    );
  };

  enterKeyPress = (e) => {
    this.state.commentText !== "" && e.key === "Enter" && this.submitComment(e);
  };

  submitComment = (e) => {
    e.preventDefault();
    this.setState({
      isCommenting: true,
      commentDisabled: true,
    });

    const commentData = {
      comment: this.state.commentText,
      job_id: this.props.jobId,
      user_id: userId,
    };

    var formData_requestPayload = new FormData();
    Object.keys(commentData).forEach((key) => {
      formData_requestPayload.append(key, commentData[key]);
    });
    this.state.files.map((file, i) => {
      formData_requestPayload.append("comment_files[]", file, file.name);
      return 0;
    });

    if (this.state.commentText !== "") {
      //   API.post("job/create_comment/0", commentData)
      API.post("job/create_comment/0", formData_requestPayload)
        .then((res) => {
          this.createNewComment();
          this.setState({
            isCommenting: false,
            commentDisabled: false,
            files: [],
          });
        })
        .catch((err) => {
          console.log("AXIOS ERROR: ", err);
          this.setState({ isCommenting: false });
        });
    } else {
      this.setState({
        isCommenting: false,
        commentDisabled: false,
      });
    }
  };

  createNewComment = () => {
    var UTCTime = new Date().toISOString();
    var correctUTC = UTCTime.split("T");
    correctUTC = correctUTC[0] + " " + correctUTC[1].split(".")[0] + ".000000";

    var lastId = this.props.comments.length
      ? this.props.comments[this.props.comments.length - 1].id
      : 1;

    var newComment = {
      comment: this.state.commentText,
      created_at: { date: correctUTC },
      user_role:
        userRole === "Title Company Admin"
          ? 2
          : userRole === "Title Company User"
          ? 3
          : 4,
      id: lastId + 1,
      user: userName,
      documents: this.state.files.map((file) => {
        return {
          file_name: file.name,
          id: null,
        };
      }),
    };
    this.setState({ commentText: "" });
    this.props.comments.push(newComment);
  };
  downloadDocument(docId, docName) {
    API.get(`job/document/` + docId + `/download`, {
      responseType: "blob",
    })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          const downloadUrl = window.URL.createObjectURL(new Blob([res.data]));

          const link = document.createElement("a");

          link.href = downloadUrl;
          link.download = docName;

          // const contentDisposition = res.headers["content-disposition"];

          // link.setAttribute("download", contentDisposition);
          document.body.appendChild(link);

          link.click();

          link.remove();
          this.setState({
            isDownloaded: true,
          });
        } else {
          this.setState({
            isDownloaded: false,
          });
        }
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
        this.setState({
          isDownloaded: false,
        });
      });
  }

  render() {
    const timeZoneDiff = new Date().getTimezoneOffset();
    const { isCommenting, commentDisabled } = this.state;
    const { comments } = this.props;

    return (
      <div className="projectCardRoot">
        <div className="commentHistoryDiv">
          {comments &&
            comments.map((comment) => {
              return (
                <div className="commentHistoryBody" key={comment.id}>
                  <div className="mobileCommentsDeck">
                    <div className="commentTime">
                      <ReactTimeAgo
                        date={
                          timeZoneDiff >= 0
                            ? new Date(
                                new Date(comment.created_at.date).getTime() -
                                  timeZoneDiff * 60000
                              )
                            : new Date(
                                new Date(comment.created_at.date).getTime() -
                                  timeZoneDiff * 60000
                              )
                        }
                      />
                    </div>
                    <div className="commenterName">@{comment.user}</div>
                  </div>
                  <div>
                    <div className="commentTextMain">
                      <div
                        className="commenterColor"
                        style={{
                          backgroundColor:
                            comment.user_role === 2 || comment.user_role === 3
                              ? "#31c680"
                              : "#97ddff",
                        }}
                      ></div>
                      <div className="commentText">{comment.comment}</div>
                    </div>
                    {comment.documents ? (
                      <div className="comment_docs">
                        {comment.documents.map((doc, i) => {
                          return (
                            <div className="comment_docItem" key={i}>
                              <p>{doc.file_name}</p>
                              {/* <a
                                download={doc.file_name}
                                href={`${process.env.REACT_APP_BACKEND_BASE_URL}/api/v1/job/document/${doc.id}/download`}
                              >
                                <GetAppIcon style={{ color: "#FFFFFF" }} />

                              </a> */}

                              <GetAppIcon
                                onClick={() =>
                                  this.downloadDocument(doc.id, doc.file_name)
                                }
                                style={{
                                  color: "#FFFFFF",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          );
                        })}
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })}
        </div>
        <div className="commentDiv">
          <div className="commentControls">
            <input
              type="text"
              id="commentText"
              name="commentText"
              className="comment"
              value={this.state.commentText}
              onChange={this.handleInputChange}
              onKeyDown={this.enterKeyPress}
              maxLength="190"
            />
            <FilePond
              allowFileTypeValidation={true}
              acceptedFileTypes={[
                "text/plain",
                "application/pdf",
                "application/doc",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/msword",
                "application/x-soffice",
                "text/richtext",
                "application/rtf",
                "application/x-iwork-pages-sffpages",
                "image/png",
                "image/jpeg",
              ]}
              ref={(ref) => (this.pond = ref)}
              files={this.state.files}
              allowMultiple={true}
              maxFiles={5}
              onupdatefiles={(fileItems) => {
                // Set currently active file objects to this.state
                this.setState({
                  files: fileItems.map((fileItem) => fileItem.file),
                });
              }}
            ></FilePond>
            <button
              className="postComment"
              onClick={this.submitComment}
              disabled={commentDisabled}
            >
              {isCommenting ? (
                <CircularProgress className="circularColor2" />
              ) : (
                <span>Post comment</span>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Comments;



// WEBPACK FOOTER //
// ./src/pages/Jobs/Comments.js